import React, { useEffect, useState } from 'react';
function getNextWebinarTime(): Date {
  const now = new Date();
  const amsterdamNow = new Date(now.toLocaleString('en-US', {
    timeZone: 'Europe/Amsterdam'
  }));
  const webinarHours = [10, 13, 20];
  for (const hour of webinarHours) {
    const target = new Date(amsterdamNow);
    target.setHours(hour, 0, 0, 0);
    if (target > amsterdamNow) {
      const offset = now.getTime() - amsterdamNow.getTime();
      return new Date(target.getTime() + offset);
    }
  }
  // All times passed today, next is 10:00 tomorrow
  const tomorrow = new Date(amsterdamNow);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(10, 0, 0, 0);
  const offset = now.getTime() - amsterdamNow.getTime();
  return new Date(tomorrow.getTime() + offset);
}
function formatCountdown(diffMs: number): string {
  if (diffMs <= 0) return '0:00:00';
  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
export const WebinarMCStickyBar = ({
  onClickCTA
}: {
  onClickCTA: () => void;
}) => {
  const [countdown, setCountdown] = useState('');
  const [nextTime, setNextTime] = useState('');
  useEffect(() => {
    const update = () => {
      const target = getNextWebinarTime();
      const diff = target.getTime() - Date.now();
      setCountdown(formatCountdown(diff));
      const targetAmsterdam = new Date(target.toLocaleString('en-US', {
        timeZone: 'Europe/Amsterdam'
      }));
      const h = targetAmsterdam.getHours();
      setNextTime(`${h}:00`);
      if (diff <= 0) {
        setTimeout(update, 1000);
      }
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-id="element-482">
      <div className="px-4 pt-2 pb-3 text-center" data-id="element-483">
        <p className="text-sm text-gray-700 mb-2" data-id="element-484">
          Volgende webinar is over{' '}
          <span className="font-bold text-[#1a2b4a]" data-id="element-485">{countdown}</span>
          <span className="text-gray-500" data-id="element-486"> ({nextTime} uur)</span>
        </p>
        <button onClick={onClickCTA} className="w-full bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-3 px-6 rounded-full transition-colors text-base shadow-md" data-id="element-487">
          Inschrijven webinar
        </button>
      </div>
    </div>;
};